// node_moduels
import { FC, MouseEvent, useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
// styles
import styles from "./technologyRate.module.scss";
// Types
import { TTechnology, TUserTechnologyRateDTO } from "Types";
// Controllers
import { TechnologyControllerSingleton } from "Controllers";
// Helpers
import { ToastHelperSingleton } from "Helpers";
// Enums
import { ToastTypeEnum } from "Enums";

type TTechnologyRateProps = {
  techRate: TUserTechnologyRateDTO | undefined,
  technology: TTechnology,
  additionalClassName?: string,
  isEditMode: boolean
}

export const TechnologyRate: FC<TTechnologyRateProps> = ({techRate, technology, additionalClassName, isEditMode}: TTechnologyRateProps) => {
  const getCurrentRate = useCallback((): number => {
    return techRate ? techRate.rate : 0;
  }, [techRate]);

  const [technologyRate, setTechnologyRate] = useState<number>(getCurrentRate());

  const updateTechnologyRate = useCallback(
    () => {
      setTechnologyRate(getCurrentRate());
    }, [getCurrentRate]);

  useEffect(() => {
    updateTechnologyRate();
  }, [techRate, updateTechnologyRate]);

  const handleOnOver = (mouseEvent: MouseEvent<SVGSVGElement>, rate: number): void => {
    if (!isEditMode) return;
    mouseEvent.stopPropagation();
    mouseEvent.preventDefault();
    setTechnologyRate(rate);
  };

  const handleOnMouseLeave = (): void => {
    if (!isEditMode) return;
    setTechnologyRate(getCurrentRate());
  };

  const handleOnClick = async (mouseEvent: MouseEvent<SVGSVGElement>, rate: number): Promise<void> => {
    if (!isEditMode) return;
    mouseEvent.stopPropagation();
    mouseEvent.preventDefault();

    setTechnologyRate(rate);
    
    // call server to add user technology rate in the DB
    const isSuccess: boolean = await TechnologyControllerSingleton.rateAsync(technology.id, rate);

    if (!isSuccess) {
        ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to rate on technology.");
    }
  };

  const getStarRateIconClassNames = (starRateIconValue: number): string => {
    return technologyRate >= starRateIconValue ? styles.ratedStarIcon : styles.fontAwesomeItem;
  };

  return (
    <div id="technology-rate-five-star" className={additionalClassName} onMouseLeave={handleOnMouseLeave}>
      {[1, 2, 3, 4, 5].map((value) => {
        return <FontAwesomeIcon
          key={value}
          className={getStarRateIconClassNames(value)}
          onMouseOver={(event) => handleOnOver(event, value)}
          onClick={(event) => handleOnClick(event, value)}
          icon={faStar} />;
      })}
    </div>
  );
};
